import script from "./ModuleVideosLessonsAnswersComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleVideosLessonsAnswersComponent.vue?vue&type=script&setup=true&lang=js"

import "./ModuleVideosLessonsAnswersComponent.vue?vue&type=style&index=0&id=83fc3946&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83fc3946"]])

export default __exports__